import styled, { css } from "styled-components";

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 5px 0px;
	align-items: flex-start;
	align-self: stretch;
	border-radius: 15px;
	background: var(--input-bg-has-value);
`;
const ContentHeader = styled.div`
	display: flex;
	padding: 5px 10px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
`;

const Date = styled.div`
	color: var(--secondary-text-color);
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const HeaderTitle = styled.div`
	color: #fcfcfc;
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;
const ContentBody = styled.div`
	display: flex;
	padding: 5px 10px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	background: var(--content-body-gradient);
`;

const Amount = styled.div`
	color: var(--content-text-color);
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

const Status = styled.div`
	display: flex;
	height: 20px;
	padding: 9px 10px;
	justify-content: center;
	align-items: center;
	gap: 12px;
	border-radius: 50px;
	color: #fcfcfc;
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}

	${({ status }) =>
		status &&
		css`
			background: ${status === "Won"
				? "linear-gradient(180deg, #18BB0C 0%, #067306 100%)"
				: status === "Lost"
					? "linear-gradient(180deg, #F0052F 0%, #940136 100%)"
					: "#6e7191"};
		`}
`;
const ContentDescription = styled.div`
	display: flex;
	padding: 10px;
	align-items: center;
	align-self: stretch;
	justify-content: center;
`;

const Description = styled.div`
	color: var(--content-text-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const DetailsButton = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	border-top: 1px solid var(--header-color);
	cursor: pointer;

	svg {
		path {
			stroke: var(--header-color);
		}
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				transform: rotate(180deg);
				animation: rotate 0.1s;
			}
		`}
`;

const ButtonText = styled.div`
	display: flex;
	color: var(--header-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	min-width: 42px;
	justify-content: flex-end;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const ContentFooter = styled.div`
	display: flex;
	width: 100%;
	padding: 10px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 5px;
	align-self: stretch;
`;

const FooterInfoWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;

	${({ hasIds }) =>
		hasIds &&
		css`
			div:first-of-type {
				justify-content: flex-start !important;
			}

			div:last-of-type {
				justify-content: flex-end !important;
			}
		`}
`;

const FooterIdInfoWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

const CopyId = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	color: var(--main-secondary-text-color);
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	height: 20px;
	padding: 2px 0px;

	${({ hasIds }) =>
		hasIds &&
		css`
			&:first-child {
				justify-content: flex-start;
			}

			&:last-child {
				justify-content: flex-end;
			}
		`}

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}

	svg {
		path {
			fill: var(--main-secondary-text-color);
		}
	}
`;

const Id = styled.div`
	display: flex;
	color: var(--main-secondary-text-color);
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const BonusInfo = styled.div`
	align-items: center;
	display: flex;
	flex: 1;
	height: 20px;
	padding: 2px 0px;
	color: var(--main-secondary-text-color);
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: center;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const PaybackInfo = styled.div`
	align-items: center;
	display: flex;
	flex: 1;
	height: 20px;
	padding: 2px 0px;
	color: var(--main-secondary-text-color);
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: flex-end;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const Note = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 20px;
	padding: 2px 0px;
	flex: 1;
	color: var(--main-secondary-text-color);
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

export {
	Amount,
	BonusInfo,
	ButtonText,
	ContentBody,
	ContentDescription,
	ContentFooter,
	ContentHeader,
	ContentWrapper,
	CopyId,
	Date,
	Description,
	DetailsButton,
	FooterIdInfoWrapper,
	FooterInfoWrapper,
	HeaderTitle,
	Id,
	Note,
	PaybackInfo,
	Status,
};
